import React from "react";
import { useTheme } from "@emotion/react";

function Icon() {
  const theme = useTheme()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      version="1.1"
      viewBox="0 0 180 157"
      xmlSpace="preserve"
    >
      <g
        fillOpacity="1"
        stroke="#fff" // {theme.palette.primary.dark}
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="1"
        strokeWidth="15.5"
      >
        <path
          fill="#fff"
          d="M50.94 127.22l88.572.137c36.797.299 46.995-54.457 1.55-65.011 3.654-43.77-51.265-66.639-79.977-29.362"
        ></path>
        <path
          fill={theme.palette.primary.main}
          d="M91.012 101.91l17.027-9.958c8.46-4.948 8.46-17.316 0-22.263L27.98 22.866c-8.46-4.947-19.033 1.237-19.033 11.131V127.644c0 9.894 10.574 16.078 19.033 11.131l18.426-10.776z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
